import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'ez-external-login-error',
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './external-login-error.component.html',
  styleUrls: ['./external-login-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalLoginErrorComponent {
  customErrorMessage: string | null = null;
  showForgotPassword = false;
  supportLink: string | null = null;

  constructor(elementRef: ElementRef) {
    const getAttribute = elementRef.nativeElement.getAttribute.bind(elementRef.nativeElement);

    this.customErrorMessage = getAttribute('custom-error-message');
    this.showForgotPassword = getAttribute('show-forgot-password') === 'show-forgot-password';
    this.supportLink = getAttribute('support-link');
  }

  forgotPassword(): void {
    window.location.href = '/Auth/Account/ForgotPassword';
  }

  restartSso(): void {
    window.location.href = '/auth/account/external-login/sso-options';
  }
}
